import { Fragment, useContext} from 'react';
import { LanguageContext } from '../../index';
import PageTitle from '../../components/pagetitle/PageTitle'
import Navbar from '../../components/Navbar/Navbar'
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import About2 from '../../components/about2/about2';
import About3 from '../../components/about3/about3';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import FunFact from '../../components/FunFact';
import TeamSection from '../../components/TeamSection/TeamSection';
import VideoSection from '../../components/VideoSection/VideoSection';

    

const AboutPage = () => {
    const { language } = useContext(LanguageContext);
    const isPolish = language === 'pl';
    return (
        <Fragment>
            <Navbar />
            <PageTitle pageTitle={isPolish ? 'O nas' : 'About us'} pagesub={isPolish ? 'Kim jesteśmy?' : 'Who we are?'} />
            <About3 />
            <ServiceSection ptClass={'pt-100'}/>
            <About2 />
            <FunFact fClass={'style-two pt-165 pb-125 mb-0'}/>
            <TeamSection/>
            <VideoSection />
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default AboutPage;
